export default [
    {
        path: 'apis/annotation_jobs',
        name: 'list-annotation-jobs',
        component: () => import('pages/external_api/annotation_jobs/list/index.vue'),
    },
    {
        path: 'apis/annotation_job/new',
        name: 'create-annotation-job',
        component: () => import('pages/external_api/annotation_jobs/create/index.vue'),
    },
    {
        path: 'apis/annotation_job/:jobId',
        name: 'edit-annotation-job',
        component: () => import('pages/external_api/annotation_jobs/create/index.vue'),
    },
    {
        path: 'apis/data_source/preview',
        name: 'job-data-source-preview',
        component: () => import('pages/external_api/annotation_jobs/create/components/data-source-preview.vue'),
    },
    {
        path: 'databases',
        name: 'list-databases',
        component: () => import('pages/external_api/databases/list/index.vue'),
    },
    {
        path: 'databases/new',
        name: 'create-database',
        component: () => import('pages/external_api/databases/create'),
    },
    {
        path: 'databases/:databaseId',
        name: 'edit-database',
        component: () => import('pages/external_api/databases/create'),
    },
];
